import React from 'react';
import styled from 'styled-components';

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 27px;

  margin-top: 48px;
  padding-top: 48px;

  border-top: 1px solid #e6e6f3;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  strong {
    font-size: 12px;
    font-weight: 400;
    color: #6a6f83;
  }
`;

const InfoRowValue = styled.div`
  font-family: Bebas Neue;
  font-size: 20px;
  font-weight: 600;
  color: ${props => props.theme.text2};
`;

const Change = styled.div`
  color: ${props => props.theme.text0};
  font-family: Bebas Neue;
  font-size: 20px;
  font-weight: 600;
`;

const Chart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 220px;
  height: 220px;
  margin: 0 auto;

  border-radius: 50%;
  border: 12px solid #00baff;

  h3 {
    margin-bottom: 4px;

    color: ${props => props.theme.text0};
    font-family: Bebas Neue;
    font-size: 32px;
    font-weight: 600;

    sup {
      position: relative;
      top: 4px;

      font-size: 20px;
    }
  }

  span {
    font-size: 12px;
    font-weight: 500;
    color: #6a6f83;
    text-transform: uppercase;
  }
`;

export default function AssetsSidebar() {
  return (
    <div>
      <Chart>
        <h3>
          <sup>$</sup>19,031.22
        </h3>
        <span>14 assets</span>
      </Chart>
      <InfoWrapper>
        <InfoRow>
          <strong>24H Change</strong>
          <Change>
            {/* <span>caret</span>  */}
            $1327.01
          </Change>
        </InfoRow>
        <InfoRow>
          <strong>Highest Balance</strong>
          <InfoRowValue>$92,442.57</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Portfolio Age</strong>
          <InfoRowValue>1 Y 2 MON</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Best 24H Asset</strong>
          <InfoRowValue>XRP</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Worst 24H Asset</strong>
          <InfoRowValue>BTC</InfoRowValue>
        </InfoRow>
      </InfoWrapper>
    </div>
  );
}
